/**
 * Single source of truth for the bearer token. Kept out of React state so the
 * axios interceptor can read it synchronously without a render dependency.
 * Persisted to localStorage so a refresh keeps the session.
 */
const STORAGE_KEY = 'nlytics.token';

let inMemoryToken: string | null = readPersisted();

function readPersisted(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export const tokenStore = {
  get(): string | null {
    return inMemoryToken;
  },
  set(token: string): void {
    inMemoryToken = token;
    try {
      window.localStorage.setItem(STORAGE_KEY, token);
    } catch {
      /* storage unavailable (private mode) — in-memory token still works */
    }
  },
  clear(): void {
    inMemoryToken = null;
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
  },
};
